import React from 'react';
import modal from '~components/modal';
import { makeStyles } from '@material-ui/styles';
import signmeup from './img/signmeup.png';
import { Button, Divider } from 'antd';
import { CheckCircleSuccess } from 'common/components/svgs';
import { useMutation } from '@apollo/client';
import { MUTATION_DS_UpdateLandlord_ListingPlan } from '../queries';
import { upperCase } from 'lodash';

const uesStyles = makeStyles(
  () => ({
    layout: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '40px 0',
    },
    thanks: {
      fontSize: '20px',
      fontWeight: 600,
      marginTop: '24px',
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '32px',
    },
    contact: {
      fontSize: '16px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.45)',
      lineHeight: '24px',
    },

    planBox: {
      borderRadius: '2px',
      background: 'rgba(245, 245, 245, 1)',
      display: 'flex',
      alignItems: 'center',
      padding: '12px 24px',
      marginTop: '24px',
    },
    img: {
      width: '320px',
      height: '200px',
    },
    bodyRegular: {
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.65)',
      lineHeight: '22px',
    },

    description_line: {
      display: 'flex',
      fontSize: '12px',
      fontWeight: 400,
      marginTop: '8px',
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '20px',
    },
  }),
  { name: 'SignmeUp-Dialog' },
);
function Index({ close, type, landlordId, callback }) {
  const classes = uesStyles();

  const [updateLandlordListingPlan, { loading: updateLoading }] = useMutation(
    MUTATION_DS_UpdateLandlord_ListingPlan,
    {
      variables: {
        input: {
          id: landlordId,
          listingPlan: upperCase(type),
        },
      },
      onCompleted: data => {
        console.log('[updateLandlordListingPlan  -> data ] >', data);
        callback && callback('success');
      },
      onError: error => {
        console.log('[updateLandlordListingPlan  -> error ] >', error);
        callback && callback('error');
      },
    },
  );

  return (
    <div className={classes.layout}>
      <img src={signmeup} className={classes.img} />
      <div className={classes.thanks}>Thanks for your feedback!</div>
      <div className={classes.contact}>Our supply team will contact you soon.</div>
      <div className={classes.planBox}>
        <CheckCircleSuccess
          style={{ width: '14px', height: '14px', marginRight: '8px', fill: '#38B2A6' }}
        />
        <div className={classes.bodyRegular}>Selected Listing Plan</div>
        <Divider type="vertical" style={{ margin: '0 16px' }} />
        <div className={classes.bodyRegular} style={{ fontWeight: '600' }}>
          {type}
        </div>
      </div>
      <Button
        type="primary"
        className={classes.contact}
        loading={updateLoading}
        onClick={() => {
          updateLandlordListingPlan();
        }}
        style={{
          fontWeight: '600',
          color: 'white',
          width: '280px',
          minHeight: '40px',
          marginTop: '40px',
        }}
      >
        Sure, I got it.
      </Button>
      <div
        className={classes.bodyRegular}
        style={{ fontWeight: '600', marginTop: '16px', cursor: 'pointer' }}
        onClick={() => {
          close && close('');
        }}
      >
        Cancel, select again
      </div>
    </div>
  );
}

export default modal({ className: 'listing-plan__modal' }, false)(Index);
